// extracted by mini-css-extract-plugin
module.exports = {"dropdownsArea":"TopicSectionManagementComponent_dropdownsArea__2XzqP","titleArea":"TopicSectionManagementComponent_titleArea__2bwBV"};